/**
 *
 * Question
 *
 */

import TimeAndAgo from '@/components/TimeAndAgo.vue';

import { FixBlankAvatarMixin } from '@/scripts/QA/mixins/FixBlankAvatarMixin';

export default {
  name: 'Comment',

  mixins: [FixBlankAvatarMixin],

  components: {
    'time-and-ago': TimeAndAgo,
  },

  props: {
    p_comment: {
      type: Object,
      default: () => ({}),
    },
  },
};
